// @ts-check
import InsuranceCoverageForms from './InsuranceCoverageForms';

export default InsuranceCoverageForms;
